import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getServiceCategories() {
  try {
    return await apiFetch<any[]>('/api/service-categories');
  } catch {
    return [];
  }
}

export async function getServiceCategoryBySlug(slug: string) {
  try {
    return await apiFetch<any>(`/api/service-categories/slug/${encodeURIComponent(slug)}`);
  } catch {
    return null;
  }
}

export async function getServiceCategoryById(id: string) {
  try {
    return await apiFetch<any>(`/api/service-categories/${id}`);
  } catch {
    return null;
  }
}

export async function createServiceCategory(data: any) {
  return apiPost('/api/service-categories', data);
}

export async function updateServiceCategory(id: string, data: any) {
  return apiPut(`/api/service-categories/${id}`, data);
}

export async function deleteServiceCategory(id: string) {
  return apiDelete(`/api/service-categories/${id}`);
}
